const validator = require("email-validator");

const app = new Vue({
  el: '#getPreviewCopyForm',
  data: {
    errors: [],
    email: null,
    showErrors: false,
  },
  methods: {
    checkDownloadPreviewCopyForm: function (e) {
      if (this.email && this.validEmail(this.email)) {
        return true;
      }

      if (!this.email) {
        this.errors.push('An email address is required.');
        this.showErrors = true;
      }

      if (!this.validEmail(this.email)) {
        this.errors.push('A valid email is required.');
        this.showErrors = true;
      }

      e.preventDefault();
    },
    validEmail: function (email) {
      return validator.validate(email);
    }
  }
})
